export default {
    NAME: 'Kaetram',
    DESCRIPTION:
        'Kaetram es un motor de videojuegos de código abierto creado para ayudar a aquellos interesados en ingresar al ámbito del desarrollo de videojuegos. La idea original se basa en el juego de demostración de Little Workshop: BrowserQuest. Los activos se han mantenido igual, pero el código en sí se ha borrado por completo y se ha rehecho desde cero.'
} as const;
